import { ReferenceArrayInput, SelectArrayInput, TextInput, required } from "react-admin";
import { Grid, Typography } from "@mui/material";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        lg={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        lg={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
      >
        <Typography color={"primary"}>Документи</Typography>
      </Grid>
      <Grid
        item
        lg={6}
        md={12}
        sm={12}
      >
        <ReferenceArrayInput
          source="documentTypeIds"
          reference={administrationRequests.getPreferenceDocumentTypesSelect()}
          label=""
        >
          <SelectArrayInput
            optionText="name"
            label="Документи"
            validate={required()}
          />
        </ReferenceArrayInput>
      </Grid>

      <Grid
        item
        lg={8}
        xs={12}
      ></Grid>
    </Grid>
  );
};
export default SaveForm;
